import React from 'react';

interface TrendChartIconProps {
  width?: number;
  height?: number;
}

export const TrendChartIcon: React.FC<TrendChartIconProps> = ({ 
  width = 130, 
  height = 32
}) => {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={width} 
      height={height} 
      fill="none" 
      viewBox="0 0 130 32"
    >
      <path 
        fill="url(#aTrendChartIcon)" 
        fillRule="evenodd" 
        d="M.924 21.59s4.999-.732 10.682 1.028c10.81 3.346 11.426-2.782 15.435-5.737 3.667-2.704 6.704-1.054 10.787 2.252 3.011 2.438 7.4 6.532 11.945 5.873 4.155-.603 7.1-5.404 12.859-6.624 4.564-.968 8.273 1.69 13.529.75 7.13-1.274 10.315-8.776 15.41-8.776 6.29 0 10.718-6.345 16.439-6.345 5.688 0 6.46 3.731 12.681 6.345 4.757 1.999 7.045 0 7.045 0v21.416H.924z" 
        clipRule="evenodd" 
        opacity=".1"
      />
      <path 
        stroke="#32d583" 
        strokeLinecap="round" 
        strokeLinejoin="round" 
        strokeWidth="1.847" 
        d="M.924 18.264s4.999-.722 10.682 1.012c10.81 3.299 11.426-2.741 15.435-5.653 3.667-2.665 6.704-1.04 10.787 2.22 3.011 2.402 7.4 6.436 11.945 5.787 4.155-.594 7.1-5.325 12.859-6.528 4.564-.954 8.273 1.666 13.529.74 7.13-1.256 10.315-8.65 15.41-8.65 6.29 0 10.718-6.268 16.439-6.268 5.688 0 5.99 3.692 12.212 6.268 4.756 1.97 7.514 0 7.514 0"
      />
      <circle 
        cx="127.736" 
        cy="6.771" 
        r="2" 
        fill="#32d583"
      />
      <defs>
        <linearGradient 
          id="aTrendChartIcon" 
          x1="23.842" 
          x2="23.842" 
          y1="18.097" 
          y2="31.772" 
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#32d583"/>
          <stop offset="1" stopColor="#fff" stopOpacity=".01"/>
        </linearGradient>
      </defs>
    </svg>
  );
};

